module.exports = __webpack_public_path__ + "img/3.d93a0991.jpg";